module.exports = __webpack_public_path__ + "img/MW.293a2fc9.png";